// import {
//   Box,
//   Button,
//   Container,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Grid,
//   Paper,
//   Popover,
//   Snackbar,
//   Table,
//   TableBody,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   Typography,
//   IconButton,
//   Tooltip,
// } from "@mui/material";
// import React, { useEffect, useState, forwardRef, useRef } from "react";
// import styles from "../../../styles.module.css";
// import { useDispatch, useSelector } from "react-redux";
// import CloseIcon from '@mui/icons-material/Close';
// import { useNavigate } from "react-router-dom";
// import {
//   ActionMsg,
//   AddButton,
//   Breadcrumb,
//   CustomePopover,
//   DateConversionOnEntryPage,
//   DeleteDialog,
//   ExcelDownload,
//   HandleCloseSnackbar,
//   HandleSort,
//   SearchInput,
//   StyledTableCell,
//   StyledTableRow,
//   useMessageHandler,
// } from "../../reusableComponent/Reusables";
// import { NavLink } from "react-router-dom";
// import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
// import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
// import ReactToPrint from "react-to-print";
// import {
//   editDeleteCylinderInward,
//   getCylinderInwardList,
// } from "../../../actions/actions";
// import inwardService from "../../../services/inward.Service";
// import HeaderSection from "../../reusableComponent/HeaderSection";
// // import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import deliveryentryService from "../../../services/deliveryentry.Service";
// import deliveryEntryprint from "./Deliveryentryprint";
// import customerMasterService from "../../../services/masters/customerMaster.Service";
// import driverMasterService from "../../../services/masters/driverMaster.Service";
// import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import CustomPagination from "../../reusableComponent/CustomPagination";

// const ComponentToPrintWrapper = ({ quotationPrint }) => {
//   const ref = useRef();
//   return (
//     <div style={{ display: "flex" }}>
//       <ReactToPrint
//         trigger={() => (
//           <span style={{ display: "flex", justifyContent: "center" }}>
//             <PrintOutlinedIcon />{" "}
//             <span style={{ marginLeft: "22px" }}> Print Record </span>
//           </span>
//         )}
//         content={() => ref.current}
//       />
//       <div style={{ display: "none" }}>
//         {/* <CylinderInwardPrint ref={ref} salesOrderPrint={quotationPrint} /> */}
//       </div>
//     </div>
//   );
// };

// const ListDeliveryEntry = () => {
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.userInfo;

//   const [isDelete, setIsDelete] = useState(false);
//   const [deleteInfo, setDeleteInfo] = useState();
//   const [sortBy, setSortBy] = useState(null);
//   const totalCount = useSelector(
//     (state) => state.cylinder_inward.total_count || 0
//   );
//   const defaultRowsPerPage = useSelector(
//     (state) => state.cylinder_inward.rows_per_page || 15
//   );
//   const [rows, setRows] = useState([]);
//   const [searchKey, setSearchKey] = useState("");
//   const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
//   const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
//   const [openImageDialog, setOpenImageDialog] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const fields = ["entry_no", "entry_date", "vehicle_no", "driver_name", "customer_name", "cylinder_count"];
//   const labels = ["Entry No", "Entry Date", "Vehicle no", "Driver", "Customer", "No Of Cylinder"];

//   const [successMessage, setSuccessMessage] = useState(null);
//   const [total_count, setTotalCount] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);
// const [selectedRow, setSelectedRow] = useState(null);
  
//   useEffect(() => {
//     setTotalCount(rows[0]?.totalCount);
//   }, [rows]);

//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: defaultRowsPerPage,
//   });

//   const [depotmap, setDepot] = useState({});
//   const [customermap, setCustomer] = useState({});
//   const [vehiclemap, setVehicle] = useState({});
//   const [cylindermap, setCylinder] = useState({});
//   const [drivermap, setDriver] = useState({});

//   useEffect(() => {
//     async function fetchMasterData() {
//       try {
//         const [depotData, customerData, vehicleData, cylinderData, driverData] =
//           await Promise.all([
//             depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//             customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//             vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
//             cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//             driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
//           ]);

//         setDepot(Object.fromEntries(depotData.map((d) => [d.depot_id, d.depot_name])));
//         setCustomer(Object.fromEntries(customerData.map((c) => [c.cust_id, c.cust_name])));
//         setVehicle(Object.fromEntries(vehicleData.map((s) => [s.vehicle_id, s.vehicle_no])));
//          setVehicle(Object.fromEntries(vehicleData.map((s) => [s.vehicle_id, s.vehicle_no])));
//        setCylinder(Object.fromEntries(cylinderData.map((s) => [s.cyl_id, { cylinder_no: s.cylinder_no, tag_no: s.tag_no || "", owner: s.owner || "TGPL" }])));
//         setDriver(Object.fromEntries(driverData.map((s) => [s.driver_id, s.driver_name])));
//       } catch (error) {
//         console.error("Data fetching failed", error);
//         setSuccessMessage("Error fetching master data");
//       }
//     }

//     fetchMasterData();
//   }, []);

//   useEffect(() => {
//     setController((prev) => ({
//       ...prev,
//       rowsPerPage: defaultRowsPerPage,
//       page: 0,
//     }));
//   }, [defaultRowsPerPage]);

//   const handleChangePage = (event, newPage) => {
//     setController({
//       ...controller,
//       page: newPage,
//     });
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       ...controller,
//       rowsPerPage: parseInt(event.target.value, 10),
//       page: 0,
//     });
//   };

// const handleOpenDialog = (row) => {
//   setSelectedRow(row);
//   try {
//     let details = JSON.parse(row.table_details || '[]');
//     if (typeof details === 'string') details = JSON.parse(details);
//     setSelectedCylinderDetails(Array.isArray(details) ? details : []);
//   } catch { setSelectedCylinderDetails([]); }
//   setOpenDialog(true);
// };

// const handleCloseDialog = () => {
//   setOpenDialog(false);
//   setSelectedRow(null);
//   setSelectedCylinderDetails([]);
// };

//  const fetchData = async () => {
//   try {
//     const params = {
//       page: controller.page,
//       size: controller.rowsPerPage,
//       searchKey: searchKey,
//     };
//     const response = await deliveryentryService.getDeliveryEntryList(params);
//   console.log('FIRST ROW:', response[0]); // ← YEH ADD KARO
//     const processedRows = response.map((row) => {
//       let cylinderCount = 0;
//       try {
//         let details = JSON.parse(row.table_details || '[]');
//         if (typeof details === 'string') details = JSON.parse(details);
//         cylinderCount = Array.isArray(details) ? details.length : 0;
//       } catch (e) {
//         console.warn('Error parsing table_details:', e);
//       }
//       return { ...row, cylinderCount };
//     });

//     setRows(processedRows);
//   } catch (error) {
//     setSuccessMessage("Error fetching data");
//   }
// };

//   const handleSearch = async (e) => {
//     const searchValue = e.target.value;
//     setSearchKey(searchValue);
//     const params = {
//       page: controller.page,
//       size: searchValue === "" ? controller.rowsPerPage : rows[0]?.total_count || 0,
//       searchKey: searchValue,
//     };
//     try {
//       await fetchData(params);
//     } catch (error) {
//       console.error("Error in handleSearch:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [controller]);

//   const deleteRecord = async (id) => {
//     try {
//       await deliveryentryService.editDeleteDeliveryEntry({
//         entry_id: id,
//         changedUpdatedValue: "delete",
//       });
//       setIsDelete(false);
//       fetchData();
//       setSuccessMessage("Record deleted successfully");
//     } catch (error) {
//       setSuccessMessage("Error deleting record");
//     }
//   };
//     const navigate = useNavigate();

//   const handleDelete = (functions) => {
//     setIsDelete(true);
//     setDeleteInfo(functions);
//   };

//   const handleClose = (event, reason) => {
//     setIsDelete(false);
//     setDeleteInfo(null);
//   };

//   const handleCylinderCountClick = (row) => {
//     try {
//       const details = JSON.parse(row.table_details);
//       setSelectedCylinderDetails(details);
//       setOpenCylinderDialog(true);
//     } catch (error) {
//       console.error("Error parsing table_details:", error);
//       setSuccessMessage("Error loading cylinder details");
//     }
//   };

//   const handleCloseCylinderDialog = () => {
//     setOpenCylinderDialog(false);
//     setSelectedCylinderDetails([]);
//   };

//   const handleImageClick = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     setOpenImageDialog(true);
//   };

//   const handleCloseImageDialog = () => {
//     setOpenImageDialog(false);
//     setSelectedImage(null);
//   };

//   // Sort rows by entry_date descending
//   const sortedRows = [...rows].sort(
//     (a, b) => new Date(b.entry_date) - new Date(a.entry_date)
//   );

//   // Calculate pagination info
//   const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
//   const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
//   const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
//   const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

//   return (
//     <Box
//       className={`${styles.cts_page}`}
//       sx={{ padding: "0px !important", margin: "0px !important" }}
//     >
//       <Box className={`${styles.body}`}>
//         <Breadcrumb
//           routeSegments={[{ name: "Delivery acknowledgement" }]}
//         />

//         <HeaderSection
//           title="DELIVERY ACKNOWLEDGEMENT LIST"
//           addNewPath="/storeEntries/Adddeliveryentry" 
//           searchKey={searchKey}
//           handleSearch={handleSearch}
//           sortedRows={sortedRows}
//           fields={fields}
//           labels={labels}
//           filename="Delivery Entry"
//           paginationInfo={paginationInfo}
//           controller={controller}
//           handleChangePage={handleChangePage}
//         />



//         <Paper sx={{ width: "100%" }}>
//           <TableContainer
//             component={Paper}
//             className={`${styles.list_tbl_container}`}
//           >
//             <Table size="" stickyHeader>
//               <TableHead>
//                 <StyledTableRow>
//                   <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
//                     Entry No
//                   </StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: '10%' }} className={styles.table_head}>
//                     Date
//                   </StyledTableCell>
//                    <StyledTableCell align="left" sx={{ width: '10%' }} className={styles.table_head}>
//                     Challan No
//                   </StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
//                     Vehicle No
//                   </StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
//                     Driver Name
//                   </StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
//                     Customer Name
//                   </StyledTableCell>
//                   <StyledTableCell align="center" sx={{ width: '15%' }} className={styles.table_head}>
//                     No Of Cylinder
//                   </StyledTableCell>
//                   <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
//                     Images
//                   </StyledTableCell>
//                   <StyledTableCell align="center" className={styles.table_head}>
//                     Action
//                   </StyledTableCell>
//                 </StyledTableRow>
//               </TableHead>

//               <TableBody sx={{ backgroundColor: "#fff" }}>
//                 {Array.isArray(sortedRows) &&
//                   sortedRows.map((row) => (
//                     <StyledTableRow
//                       key={row.entry_no}
//                       sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
//                     >
//                     <StyledTableCell align="left" className={styles.list_table_body}>
//   <Typography
//     sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2", textDecoration: "underline" }}
//     onClick={() => handleOpenDialog(row)}
//   >
//     {row.entry_no}
//   </Typography>
// </StyledTableCell>

//                       <StyledTableCell align="left" className={styles.list_table_body}>
//                         {DateConversionOnEntryPage(row.entry_date)}
//                       </StyledTableCell>
//                        <StyledTableCell align="left" className={styles.list_table_body}>
//                         {row.challanNo}
//                       </StyledTableCell>


//                       <StyledTableCell align="left" className={styles.list_table_body}>
//                   {row.vehicle_no || vehiclemap[row.from_vehicle_id] || "N/A"}
//                       </StyledTableCell>

//                       <StyledTableCell align="left" className={styles.list_table_body}>
//                        {row.driver_name || drivermap[row.driver_id] || "N/A"}
//                       </StyledTableCell>

//                       <StyledTableCell align="left" className={styles.list_table_body}>
//                         {customermap[row.to_customer_id] || row.to_customer_id || "N/A"}
//                       </StyledTableCell>

//                       <StyledTableCell align="center" className={styles.list_table_body}>
//                         <Tooltip title="Click here to view cylinder details" arrow>
//                           <span
//                             onClick={() => handleCylinderCountClick(row)}
//                             style={{ cursor: "pointer", color: "#1976d2" }}
//                           >
//                             {row.cylinderCount || "N/A"}
//                           </span>
//                         </Tooltip>
//                       </StyledTableCell>

//                       <StyledTableCell align="left" className={styles.list_table_body}>
//                         {row.upload_receipt ? (
//                           (() => {
//                             try {
//                              let imageUrls = JSON.parse(row.upload_receipt);
// if (typeof imageUrls === 'string') imageUrls = JSON.parse(imageUrls);
// if (!Array.isArray(imageUrls)) imageUrls = [imageUrls];
// const fixedUrls = imageUrls.map(url => 
//   url.replace(/http:\/\/[\d.]+:\d+/, `http://${window.location.hostname}:5000`)
// );
// return fixedUrls.map((url, index) => (
//                                 <Tooltip key={index} title="Click to view full image" arrow>
//                                   <img
//                                     src={url}
//                                     alt={`Receipt ${index + 1}`}
//                                     style={{
//                                       width: '50px',
//                                       height: '50px',
//                                       objectFit: 'cover',
//                                       marginRight: '5px',
//                                       cursor: 'pointer',
//                                       border: '1px solid #ddd',
//                                       borderRadius: '4px'
//                                     }}
//                                     onClick={() => handleImageClick(url)}
//                                   />
//                                 </Tooltip>
//                               ));
//                             } catch (error) {
//                               console.error("Invalid JSON in upload_receipt:", error);
//                               return <span>Invalid receipt format</span>;
//                             }
//                           })()
//                         ) : (
//                           <span>No image</span>
//                         )}
//                       </StyledTableCell>

//                       <StyledTableCell align="center">
//                         <CustomePopover
//                           row={row}
//                           handleDelete={false}
//                           linkTo="/storeEntries/Adddeliveryentry"
//                           showEdit={false}
//                           handlePrint={false}
//                              handleCancel={false}
//                         />
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//                              <CustomPagination
//   page={controller.page}
//   rowsPerPage={controller.rowsPerPage}
//   totalCount={total_count || 0}
//   onPageChange={(newPage) => handleChangePage(null, newPage)}
// />
//         </Paper>

//         <Dialog
//           open={openCylinderDialog}
//           onClose={handleCloseCylinderDialog}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             Cylinder Details ({selectedCylinderDetails.length} Cylinders)
//             <IconButton
//               aria-label="close"
//               onClick={handleCloseCylinderDialog}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>

//           <DialogContent>
//             <Table size="small">
//               <TableHead>
//                 <StyledTableRow>
//                   <StyledTableCell>Cylinder No</StyledTableCell>
//                   <StyledTableCell>Tag No</StyledTableCell>
//                   <StyledTableCell>Owner</StyledTableCell>
//                 </StyledTableRow>
//               </TableHead>
//               <TableBody>
//                 {selectedCylinderDetails.map((cylinder, index) => (
//                   <StyledTableRow key={index}>
//                     <StyledTableCell>{cylinder.cyl_no || "N/A"}</StyledTableCell>
//                     <StyledTableCell>{cylinder.tag_no || "N/A"}</StyledTableCell>
//                     <StyledTableCell>
//                       {cylindermap[cylinder.cyl_id]?.owner || "TGPL"}
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </DialogContent>
//         </Dialog>

//         <Dialog
//           open={openImageDialog}
//           onClose={handleCloseImageDialog}
//           maxWidth="md"
//           fullWidth
//         >
//           <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             Receipt Image
//             <IconButton
//               aria-label="close"
//               onClick={handleCloseImageDialog}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent>
//             {selectedImage && (
//               <img
//                 src={selectedImage}
//                 alt="Full Receipt"
//                 style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
//               />
//             )}
//           </DialogContent>
//         </Dialog>
//         <Dialog
//   open={openDialog}
//   onClose={handleCloseDialog}
//   maxWidth={false}
//   sx={{
//     "& .MuiDialog-paper": {
//       margin: "auto", width: "92vw", maxHeight: "85vh",
//       boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
//       overflow: "hidden", fontFamily: "'Inter', Arial, sans-serif",
//     },
//   }}
// >
//   {/* Header */}
//   <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//     <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
//       DELIVERY ACKNOWLEDGEMENT DETAILS
//     </Typography>
//     <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
//       <CloseIcon fontSize="small" />
//     </IconButton>
//   </Box>

//   <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

//     {/* Info Card */}
//     <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>
//       <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
//         <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
//           📋 Delivery Information
//         </Typography>
//       </Box>
//       <Box>
//         <Grid container>
//           <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
//             <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Entry No</Typography>
//             <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E" }}>{selectedRow?.entry_no || "—"}</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
//             <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Date</Typography>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{DateConversionOnEntryPage(selectedRow?.entry_date) || "—"}</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
//             <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Challan No</Typography>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.challanNo || "—"}</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
//             <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Customer Name</Typography>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{customermap[selectedRow?.to_customer_id] || "—"}</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
//             <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Driver Name</Typography>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{drivermap[selectedRow?.driver_id] || "—"}</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
//             <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Vehicle No</Typography>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{vehiclemap[selectedRow?.from_vehicle_id] || "—"}</Typography>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
//             <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>No of Cylinders</Typography>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedCylinderDetails?.length > 0 ? selectedCylinderDetails.length : "—"}</Typography>
//           </Grid>
//         </Grid>
//       </Box>
//     </Box>

//     {/* Cylinder Details Table */}
//     <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>
//       <TableContainer sx={{ maxHeight: "320px" }}>
//         <Table size="small" stickyHeader>
//           <TableHead>
//             <StyledTableRow>
//               {["Sr No", "Cylinder No", "Tag No", "Owner"].map((header) => (
//                 <StyledTableCell key={header} align="center"
//                   sx={{ backgroundColor: "#1C3A5E !important", color: "#fff !important", fontWeight: 700, fontSize: "12px", padding: "10px 12px", whiteSpace: "nowrap" }}>
//                   {header}
//                 </StyledTableCell>
//               ))}
//             </StyledTableRow>
//           </TableHead>
//           <TableBody>
//             {selectedCylinderDetails.length > 0 ? (
//               selectedCylinderDetails.map((cyl, index) => (
//                 <StyledTableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC", "&:hover": { backgroundColor: "#EBF4FF" } }}>
//                   {[
//                     index + 1,
//   cyl.cyl_no || "—",
//   cyl.tag_no || cylindermap[cyl.cyl_id]?.tag_no || "—",
//   cylindermap[cyl.cyl_id]?.owner || "TGPL",
//                   ].map((val, ci) => (
//                     <StyledTableCell key={ci} align="center"
//                       sx={{ fontSize: "12px", color: "#2D3748", padding: "8px 12px", borderBottom: "1px solid #EDF2F7", whiteSpace: "nowrap" }}>
//                       {val}
//                     </StyledTableCell>
//                   ))}
//                 </StyledTableRow>
//               ))
//             ) : (
//               <StyledTableRow>
//                 <StyledTableCell colSpan={4} align="center" sx={{ py: 5, fontSize: "13px", color: "#A0AEC0" }}>
//                   No cylinder details available
//                 </StyledTableCell>
//               </StyledTableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>

//   </DialogContent>

//   {/* Footer */}
//   <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
//     <Button onClick={handleCloseDialog}
//       sx={{ background: "#E53E3E", color: "#fff", fontSize: "13px", fontWeight: 600, textTransform: "none", padding: "7px 20px", borderRadius: "8px", "&:hover": { background: "#971f16" } }}>
//       Close
//     </Button>
//   </Box>
// </Dialog>

//         <DeleteDialog
//           open={isDelete}
//           handleClose={handleClose}
//           deleteInfo={deleteInfo}
//           deleteRecord={deleteRecord}
//           deleteID={deleteInfo?.entry_id || null}
//           displayName={deleteInfo?.entry_id || ""}
//         />
//         {/* <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(event, reason) => {
//             if (reason !== "clickaway") {
//               setSuccessMessage("");
//             }
//           }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         /> */}
//       </Box>
//     </Box>
//   );
// };

// export default ListDeliveryEntry;

import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState, forwardRef, useRef } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { NavLink } from "react-router-dom";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import ReactToPrint from "react-to-print";
import {
  editDeleteCylinderInward,
  getCylinderInwardList,
} from "../../../actions/actions";
import inwardService from "../../../services/inward.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import deliveryentryService from "../../../services/deliveryentry.Service";
import deliveryEntryprint from "./Deliveryentryprint";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import driverMasterService from "../../../services/masters/driverMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import CustomPagination from "../../reusableComponent/CustomPagination";

const ComponentToPrintWrapper = ({ quotationPrint }) => {
  const ref = useRef();
  return (
    <div style={{ display: "flex" }}>
      <ReactToPrint
        trigger={() => (
          <span style={{ display: "flex", justifyContent: "center" }}>
            <PrintOutlinedIcon />{" "}
            <span style={{ marginLeft: "22px" }}> Print Record </span>
          </span>
        )}
        content={() => ref.current}
      />
      <div style={{ display: "none" }}>
        {/* <CylinderInwardPrint ref={ref} salesOrderPrint={quotationPrint} /> */}
      </div>
    </div>
  );
};

const ListDeliveryEntry = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(
    (state) => state.cylinder_inward.total_count || 0
  );
  const defaultRowsPerPage = useSelector(
    (state) => state.cylinder_inward.rows_per_page || 15
  );
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const fields = ["entry_no", "entry_date", "vehicle_no", "driver_name", "customer_name", "cylinder_count"];
  const labels = ["Entry No", "Entry Date", "Vehicle no", "Driver", "Customer", "No Of Cylinder"];

  const [successMessage, setSuccessMessage] = useState(null);
  const [total_count, setTotalCount] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
  
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);

  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const [depotmap, setDepot] = useState({});
  const [customermap, setCustomer] = useState({});
  const [vehiclemap, setVehicle] = useState({});
  const [cylindermap, setCylinder] = useState({});
  const [drivermap, setDriver] = useState({});

  useEffect(() => {
    async function fetchMasterData() {
      try {
        const [depotData, customerData, vehicleData, cylinderData, driverData] =
          await Promise.all([
            depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
            customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
            vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
            cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
            driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
          ]);

        setDepot(Object.fromEntries(depotData.map((d) => [d.depot_id, d.depot_name])));
        setCustomer(Object.fromEntries(customerData.map((c) => [c.cust_id, c.cust_name])));
        setVehicle(Object.fromEntries(vehicleData.map((s) => [s.vehicle_id, s.vehicle_no])));
         setVehicle(Object.fromEntries(vehicleData.map((s) => [s.vehicle_id, s.vehicle_no])));
       setCylinder(Object.fromEntries(cylinderData.map((s) => [s.cyl_id, { cylinder_no: s.cylinder_no, tag_no: s.tag_no || "", owner: s.owner || "TGPL" }])));
        setDriver(Object.fromEntries(driverData.map((s) => [s.driver_id, s.driver_name])));
      } catch (error) {
        console.error("Data fetching failed", error);
        setSuccessMessage("Error fetching master data");
      }
    }

    fetchMasterData();
  }, []);

  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

const handleOpenDialog = (row) => {
  setSelectedRow(row);
  try {
    let details = JSON.parse(row.table_details || '[]');
    if (typeof details === 'string') details = JSON.parse(details);
    setSelectedCylinderDetails(Array.isArray(details) ? details : []);
  } catch { setSelectedCylinderDetails([]); }
  setOpenDialog(true);
};

const handleCloseDialog = () => {
  setOpenDialog(false);
  setSelectedRow(null);
  setSelectedCylinderDetails([]);
};

 const fetchData = async () => {
  try {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey: searchKey,
    };
    const response = await deliveryentryService.getDeliveryEntryList(params);
  console.log('FIRST ROW:', response[0]); // ← YEH ADD KARO
     console.log('driver_name:', response[0]?.driver_name); // YEH ADD KARO
    console.log('vehicle_no:', response[0]?.vehicle_no); 
    const processedRows = response.map((row) => {
      let cylinderCount = 0;
      try {
        let details = JSON.parse(row.table_details || '[]');
        if (typeof details === 'string') details = JSON.parse(details);
        cylinderCount = Array.isArray(details) ? details.length : 0;
      } catch (e) {
        console.warn('Error parsing table_details:', e);
      }
      return { ...row, cylinderCount };
    });

    setRows(processedRows);
  } catch (error) {
    setSuccessMessage("Error fetching data");
  }
};

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    const params = {
      page: controller.page,
      size: searchValue === "" ? controller.rowsPerPage : rows[0]?.total_count || 0,
      searchKey: searchValue,
    };
    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  const deleteRecord = async (id) => {
    try {
      await deliveryentryService.editDeleteDeliveryEntry({
        entry_id: id,
        changedUpdatedValue: "delete",
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };
    const navigate = useNavigate();

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const handleCylinderCountClick = (row) => {
    try {
      const details = JSON.parse(row.table_details);
      setSelectedCylinderDetails(details);
      setOpenCylinderDialog(true);
    } catch (error) {
      console.error("Error parsing table_details:", error);
      setSuccessMessage("Error loading cylinder details");
    }
  };

  const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenImageDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
    setSelectedImage(null);
  };

  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort(
    (a, b) => new Date(b.entry_date) - new Date(a.entry_date)
  );

  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  return (
    <Box
      className={`${styles.cts_page}`}
      sx={{ padding: "0px !important", margin: "0px !important" }}
    >
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[{ name: "Delivery acknowledgement" }]}
        />

        <HeaderSection
          title="DELIVERY ACKNOWLEDGEMENT LIST"
          addNewPath="/storeEntries/Adddeliveryentry" 
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Delivery Entry"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />



        <Paper sx={{ width: "100%" }}>
          <TableContainer
            component={Paper}
            className={`${styles.list_tbl_container}`}
          >
            <Table size="" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
                    Entry No
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: '10%' }} className={styles.table_head}>
                    Challan No
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: '10%' }} className={styles.table_head}>
                   Challan Date
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
                    Customer Name
                  </StyledTableCell>
                   <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
                    Driver Name
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
                    Vehicle No
                  </StyledTableCell>
                 
                 
                  <StyledTableCell align="center" sx={{ width: '15%' }} className={styles.table_head}>
                    No Of Cylinder
                  </StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: '15%' }} className={styles.table_head}>
                    Images
                  </StyledTableCell>
                  {/* <StyledTableCell align="center" className={styles.table_head}>
                    Action
                  </StyledTableCell> */}
                </StyledTableRow>
              </TableHead>

              <TableBody sx={{ backgroundColor: "#fff" }}>
                {Array.isArray(sortedRows) &&
                  sortedRows.map((row) => (
                    <StyledTableRow
                      key={row.entry_no}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                    <StyledTableCell align="left" className={styles.list_table_body}>
  <Typography
    sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2", textDecoration: "underline" }}
    onClick={() => handleOpenDialog(row)}
  >
    {row.entry_no}
  </Typography>
</StyledTableCell>
<StyledTableCell align="left" className={styles.list_table_body}>
                        {row.challanNo}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={styles.list_table_body}>
                        {DateConversionOnEntryPage(row.entry_date)}
                      </StyledTableCell>
                       
 <StyledTableCell align="left" className={styles.list_table_body}>
                        {customermap[row.to_customer_id] || row.to_customer_id || "N/A"}
                      </StyledTableCell>
                        <StyledTableCell align="left" className={styles.list_table_body}>
                     {row.driver_name || row.unregistered_driver || drivermap[row.driver_id] || "N/A"}
                      </StyledTableCell>

                      <StyledTableCell align="left" className={styles.list_table_body}>
                     {row.vehicle_no || row.unregistered_vehicle || vehiclemap[row.from_vehicle_id] || "N/A"}
                      </StyledTableCell>

                    

                     

                      <StyledTableCell align="center" className={styles.list_table_body}>
                        <Tooltip title="Click here to view cylinder details" arrow>
                          <span
                            onClick={() => handleCylinderCountClick(row)}
                            style={{ cursor: "pointer", color: "#1976d2" }}
                          >
                            {row.cylinderCount || "N/A"}
                          </span>
                        </Tooltip>
                      </StyledTableCell>

                      <StyledTableCell align="left" className={styles.list_table_body}>
                        {row.upload_receipt ? (
                          (() => {
                            try {
                             let imageUrls = JSON.parse(row.upload_receipt);
if (typeof imageUrls === 'string') imageUrls = JSON.parse(imageUrls);
if (!Array.isArray(imageUrls)) imageUrls = [imageUrls];
const fixedUrls = imageUrls.map(url => 
  url.replace(/http:\/\/[\d.]+:\d+/, `http://${window.location.hostname}:5000`)
);
return fixedUrls.map((url, index) => (
                                <Tooltip key={index} title="Click to view full image" arrow>
                                  <img
                                    src={url}
                                    alt={`Receipt ${index + 1}`}
                                    style={{
                                      width: '50px',
                                      height: '50px',
                                      objectFit: 'cover',
                                      marginRight: '5px',
                                      cursor: 'pointer',
                                      border: '1px solid #ddd',
                                      borderRadius: '4px'
                                    }}
                                    onClick={() => handleImageClick(url)}
                                  />
                                </Tooltip>
                              ));
                            } catch (error) {
                              console.error("Invalid JSON in upload_receipt:", error);
                              return <span>Invalid receipt format</span>;
                            }
                          })()
                        ) : (
                          <span>No image</span>
                        )}
                      </StyledTableCell>

                      {/* <StyledTableCell align="center">
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/storeEntries/Adddeliveryentry"
                          showEdit={false}
                          handlePrint={false}
                             handleCancel={false}
                        />
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
                             <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        <Dialog
          open={openCylinderDialog}
          onClose={handleCloseCylinderDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex',fontSize:'16px', mt:'-10px',mb:'-10px',justifyContent: 'space-between', alignItems: 'center' }}>
            Cylinder Details ({selectedCylinderDetails.length} Cylinders)
            <IconButton
              aria-label="close"
              onClick={handleCloseCylinderDialog}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <Table size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Cylinder No</StyledTableCell>
                  <StyledTableCell>Tag No</StyledTableCell>
                  <StyledTableCell>Owner</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {selectedCylinderDetails.map((cylinder, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{cylinder.cyl_no || "N/A"}</StyledTableCell>
                    <StyledTableCell>{cylinder.tag_no || cylindermap[cylinder.cyl_id]?.tag_no || "N/A"}</StyledTableCell>
                    <StyledTableCell>
                      {cylindermap[cylinder.cyl_id]?.owner || "TGPL"}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openImageDialog}
          onClose={handleCloseImageDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Receipt Image
            <IconButton
              aria-label="close"
              onClick={handleCloseImageDialog}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Full Receipt"
                style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
              />
            )}
          </DialogContent>
        </Dialog>
        <Dialog
  open={openDialog}
  onClose={handleCloseDialog}
  maxWidth={false}
  sx={{
    "& .MuiDialog-paper": {
      margin: "auto", width: "92vw", maxHeight: "85vh",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      overflow: "hidden", fontFamily: "'Inter', Arial, sans-serif",
    },
  }}
>
  {/* Header */}
  <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
      DELIVERY ACKNOWLEDGEMENT DETAILS
    </Typography>
    <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>

  <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

    {/* Info Card */}
    <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>
      <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
          📋 Delivery Information
        </Typography>
      </Box>
      <Box>
        <Grid container>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Entry No</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E" }}>{selectedRow?.entry_no || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Date</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{DateConversionOnEntryPage(selectedRow?.entry_date) || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Challan No</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.challanNo || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Customer Name</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{customermap[selectedRow?.to_customer_id] || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Driver Name</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.driver_name || drivermap[selectedRow?.driver_id] || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Vehicle No</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.vehicle_no || vehiclemap[selectedRow?.from_vehicle_id] || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>No of Cylinders</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedCylinderDetails?.length > 0 ? selectedCylinderDetails.length : "—"}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>

    {/* Cylinder Details Table */}
    <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: "320px" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <StyledTableRow>
              {["Sr No", "Cylinder No", "Tag No", "Owner"].map((header) => (
                <StyledTableCell key={header} align="center"
                  sx={{ backgroundColor: "#1C3A5E !important", color: "#fff !important", fontWeight: 700, fontSize: "12px", padding: "10px 12px", whiteSpace: "nowrap" }}>
                  {header}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {selectedCylinderDetails.length > 0 ? (
              selectedCylinderDetails.map((cyl, index) => (
                <StyledTableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC", "&:hover": { backgroundColor: "#EBF4FF" } }}>
                  {[
                    index + 1,
  cyl.cyl_no || "—",
  cyl.tag_no || cylindermap[cyl.cyl_id]?.tag_no || "—",
  cylindermap[cyl.cyl_id]?.owner || "TGPL",
                  ].map((val, ci) => (
                    <StyledTableCell key={ci} align="center"
                      sx={{ fontSize: "12px", color: "#2D3748", padding: "8px 12px", borderBottom: "1px solid #EDF2F7", whiteSpace: "nowrap" }}>
                      {val}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={4} align="center" sx={{ py: 5, fontSize: "13px", color: "#A0AEC0" }}>
                  No cylinder details available
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>

  </DialogContent>

  {/* Footer */}
  <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
    <Button onClick={handleCloseDialog}
      sx={{ background: "#E53E3E", color: "#fff", fontSize: "13px", fontWeight: 600, textTransform: "none", padding: "7px 20px", borderRadius: "8px", "&:hover": { background: "#971f16" } }}>
      Close
    </Button>
  </Box>
</Dialog>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ""}
        />
        {/* <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        /> */}
      </Box>
    </Box>
  );
};

export default ListDeliveryEntry;